import { render, staticRenderFns } from "./PortalNavbar.vue?vue&type=template&id=7b6a5553&scoped=true&"
import script from "./PortalNavbar.vue?vue&type=script&lang=js&"
export * from "./PortalNavbar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b6a5553",
  null
  
)

export default component.exports